import PropTypes from 'prop-types';
import React from 'react';

import I18n from 'utils/I18n';

const Recommendation = ({ value, onClick }) => (
  <div className="PdpSizeChart__recommendation w-full text-xs">
    {value && (
      <span className="PdpSizeChart__recommendation-value mr-1 leading-normal tracking-wider">
        {value}
      </span>
    )}

    <button
      data-testid="pdp-size-chart-recommendation-link"
      onClick={onClick}
      className="PdpSizeChart__recommendation-link font-medium underline"
    >
      {I18n.localize('pdp.sizeChart.see')}
    </button>
  </div>
);

Recommendation.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

Recommendation.defaultProps = { value: '' };

export default Recommendation;
